export class UserAddress {
    public id!: number;
    public type!: string;
    public addressLineOne!: string;
    public addressLineTwo!: string;
    public buildingDetails!: string;
    public province!: string;
    public provinceName!: string;
    public city!: string;
    public cityName!: string;
    public cityId!: string;
    public suburb!: string;
    public postalCode!: string;
    public longitude!: number;
    public latitude!: number;
    public formattedAddress!: string;

    /**
     * Uses Partial<T> so this model can be instantiated with
     * any subset of fields (e.g. from API responses or empty init).
     * All provided properties are shallow-assigned onto the instance.
     * The default empty object lets us safely call `new UserAddress()`
     * without providing all fields.
     */
    constructor(data: Partial<UserAddress> = {}) {
        Object.assign(this, data);
    }
}
